var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getColor } from "../../../theme";
var borderMap = {
    all: function (_a) {
        var size = _a.size, type = _a.type, color = _a.color;
        return "\n    border: ".concat(size, " ").concat(type, " ").concat(color, ";\n  ");
    },
    horizontal: function (_a) {
        var size = _a.size, type = _a.type, color = _a.color;
        return "\n    border-top: ".concat(size, " ").concat(type, " ").concat(color, ";\n    border-bottom: ").concat(size, " ").concat(type, " ").concat(color, ";\n  ");
    },
    vertical: function (_a) {
        var size = _a.size, type = _a.type, color = _a.color;
        return "\n    border-left: ".concat(size, " ").concat(type, " ").concat(color, ";\n    border-right: ").concat(size, " ").concat(type, " ").concat(color, ";\n  ");
    },
    top: function (_a) {
        var size = _a.size, type = _a.type, color = _a.color;
        return "\n    border-top: ".concat(size, " ").concat(type, " ").concat(color, ";\n  ");
    },
    right: function (_a) {
        var size = _a.size, type = _a.type, color = _a.color;
        return "\n    border-right: ".concat(size, " ").concat(type, " ").concat(color, ";\n  ");
    },
    bottom: function (_a) {
        var size = _a.size, type = _a.type, color = _a.color;
        return "\n    border-bottom: ".concat(size, " ").concat(type, " ").concat(color, ";\n  ");
    },
    left: function (_a) {
        var size = _a.size, type = _a.type, color = _a.color;
        return "\n    border-left: ".concat(size, " ").concat(type, " ").concat(color, ";\n  ");
    },
};
var getDefaults = function (theme) { return ({
    color: getColor("border")({ theme: theme }),
    size: "1px",
    side: "all",
    type: "solid",
}); };
export default (function (_a) {
    var theme = _a.theme, border = _a.border;
    if (border === undefined) {
        return "";
    }
    if (border === true) {
        return borderMap.all(getDefaults(theme));
    }
    if (border in borderMap) {
        return borderMap[border](getDefaults(theme));
    }
    if (typeof border !== "object") {
        return "";
    }
    var side = border.side, color = border.color;
    return (side in borderMap &&
        borderMap[side](__assign(__assign(__assign({}, getDefaults(theme)), border), { color: getColor(color || "border")({ theme: theme }) })));
});
